/**
 * Mapeo nombre de departamento (JWT / IdP) → código de 4 letras (rAuthAssignments).
 */

/** @type {Readonly<Record<string, string>>} */
const DEPARTMENT_NAME_TO_CODE = {
  Management: 'MANAG',
  Operations: 'OPER',
  Production: 'PROD',
  Maintenance: 'MAIN',
  Quality: 'QUAL',
  Logistics: 'LOG',
  Engineering: 'ENG',
  Administration: 'ADM',
  'Human Resources': 'HR',
  'Operational Technology': 'OT',
}

/** Códigos válidos tal cual si ya vienen en el JWT */
const VALID_CODES = new Set(Object.values(DEPARTMENT_NAME_TO_CODE))

/**
 * @param {string | null | undefined} department
 * @returns {string | null}
 */
export function departmentToCode(department) {
  if (!department || typeof department !== 'string') return null
  const trimmed = department.trim()
  if (!trimmed) return null
  const upper = trimmed.toUpperCase()
  if (VALID_CODES.has(upper)) return upper
  if (DEPARTMENT_NAME_TO_CODE[trimmed]) return DEPARTMENT_NAME_TO_CODE[trimmed]
  // Coincidencia parcial (p. ej. "Production Department")
  const lower = trimmed.toLowerCase()
  for (const [name, code] of Object.entries(DEPARTMENT_NAME_TO_CODE)) {
    if (lower.includes(name.toLowerCase())) return code
  }
  return null
}

/**
 * Alias de rol en IdP → nombre canónico del catálogo.
 * @type {Readonly<Record<string, string>>}
 */
const ROLE_ALIASES = {
  Operador: 'Operator',
  operador: 'Operator',
}

/**
 * @param {string} role
 * @returns {string}
 */
export function normalizeRoleName(role) {
  if (!role) return role
  return ROLE_ALIASES[role] ?? role
}
